"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FENCE_BL_NON_TITLE_DOCUMENT_TYPES = exports.FENCE_TITLE_DOC_WIRE = exports.TITLE_DOCUMENT_TYPES = void 0;
exports.isTitleDocumentType = isTitleDocumentType;
exports.isFenceBlNonTitleDocumentType = isFenceBlNonTitleDocumentType;
// The document types that evidence title to the goods — what a financing partner
// (Rivonia, via Fence) holds as security. A title document is an ocean Bill of
// Lading, a CMR (road transport), a multimodal Bill of Lading, or a weighbridge
// ticket. This is the SINGLE source of truth: the eligibility `title_document_present`
// fact and the data-tape/Fence title-document emission both read this set, so the
// "is this a title document?" question is answered in exactly one place.
//
// Typed `satisfies readonly BLOrderDocumentType[]` so every title-document type is
// provably an uploadable document type — a value here that is not in
// BL_ORDER_DOCUMENT_TYPES fails the build.
exports.TITLE_DOCUMENT_TYPES = [
    'bill_of_lading',
    'cmr',
    'multimodal_bill_of_lading',
    'weighbridge_ticket',
];
function isTitleDocumentType(value) {
    return exports.TITLE_DOCUMENT_TYPES.includes(value);
}
exports.FENCE_TITLE_DOC_WIRE = {
    bill_of_lading: 'bl',
    cmr: 'cmr',
    multimodal_bill_of_lading: 'multimodal_bl',
    weighbridge_ticket: 'weighbridge_ticket',
};
/**
 * BL-level documents Fence wants that are NOT documents of title.
 *
 * Three types, for two different reasons, and the shared reason is what puts them
 * here: none of them evidences title, the registry carries each with
 * `title_document = false`, and both the eligibility `title_document_present` fact
 * and the tape's `title_doc_type` projection read the title set — none of these may
 * answer either of those.
 *
 * So they need their own list: the Fence delivery path resolves them alongside the
 * title documents, and nothing else does.
 */
exports.FENCE_BL_NON_TITLE_DOCUMENT_TYPES = [
    'loading_ticket',
    // The weight ticket ops actually use. The registry also carries
    // `weighbridge_ticket` as a title type, but the Excel-handover resolver
    // (`documents_to_fence.py`, Markus) reads `weight_certificate` — labelled
    // "Weight Ticket", one per container — and prod holds no `weighbridge_ticket`
    // documents at all. Both are mapped so the category is populated whichever
    // slot an operator used.
    'weight_certificate',
    // The DRAFT bill of lading (#2007), which Fence takes as its own category.
    // Their 4 Sep revision splits the B/L in two: "the draft is `bill_of_landing`,
    // the final is `final_bill_of_lading`. Those two are separate registrations,
    // each with its own `document_external_id`; neither supersedes the other, both
    // stay on record, and both are extracted independently." Two of their checks
    // compare the pair document-against-document, so the draft has to travel as a
    // document in its own right rather than being superseded by the final.
    //
    // It stays OUT of the title set deliberately: a line holding only a draft holds
    // no document of title, which is exactly what keeps `is_final_bl` false there
    // (`isFinalBl` requires a live title document — see data-tape.lifecycle.ts).
    'draft_bl',
];
function isFenceBlNonTitleDocumentType(value) {
    return exports.FENCE_BL_NON_TITLE_DOCUMENT_TYPES.includes(value);
}
//# sourceMappingURL=title-document-types.js.map